import { useContext } from 'react';
import { ToggleUploadDisplayContext } from '../Context';

export const useToggleUploadDisplay = () => {
  const toggle = useContext(ToggleUploadDisplayContext);

  return toggle;
};

export default useToggleUploadDisplay;